import React from "react";

const WhyWeAsk = ({ title, description }: { title: string; description: string }) => {
  return (
    <div className="flex flex-col pb-3">
      <div
        className="py-2 px-4 rounded-tl-[10px] rounded-tr-[10px]"
        style={{
          background: "linear-gradient(90deg, #E2E5D5 0%, #F3F4ED 100%)",
        }}
      >
        <h3 className="text-primary captitle-10 font-bold tracking-[2px]">
          {title}
        </h3>
      </div>
      <div className="bg-[#F3F4ED] rounded-bl-[10px] rounded-br-[10px]">
        <p className="text-primary title-14 px-4 py-4 pt-[10px]"
        id="hint-text"
        data-testid="hint-text"
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default WhyWeAsk;
